<template>
  <div v-if="page.service" class="page page-white page-service">
    <div class="container">
      <div v-html="page.service.text_lead" class="lead lead-intro col-md-12"/>

      <div class="col-md-12 col-service col-service-first">
        <h1>{{ page.service.title }}</h1>
      </div>

      <div class="col-md-12 col-service col-service-space">  
        <div v-html="page.service.text_main_title" class="font-grotesque"/>
        <div class="col-service-text" v-html="page.service.text_main"/>
      </div>

      <div class="col-md-12 col-service col-service-hulk">
        <div class="font-grotesque" v-html="page.service.text_law_title"/>
        <div class="col-service-text" v-html="page.service.text_law"/>
      </div>

      <div class="col-md-12 col-service col-service-parachute">
        <div class="font-grotesque" v-html="page.service.text_corporate_title"/>
        <div class="col-service-text" v-html="page.service.text_corporate"/>
      </div>

      <div class="col-md-12 col-service col-service-cubes">
        <div class="font-grotesque" v-html="page.service.text_actives_title"/>
        <div class="col-service-text" v-html="page.service.text_actives"/>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'service',
  computed: mapGetters({
    page: 'page',
  }),
};
</script>

<style>
.page{
  &-service{
    position: relative;
    z-index: 11;

    .lead-intro{
      min-height: 170px;
    }

    .col-service{
      @media (min-width: $mediaMini) {
        min-height: 330px;
      }
    }

    @media (max-width: $mediaSmallScreen) {
      .col-service .animation {
        right: -15vw;
      }
    }

    .col-service{
      margin: 70px 0 85px;
      max-width: 90%;

      @media (max-width: 1500px) {
        max-width: 100%;
      }

      @media (max-width: $mediaSmallScreen) {
        max-width: 95%;
      }
      @media (max-width: $mediaIpad) {
        h3{
          max-width: 80%;
        }
      }

      &-space,
      &-cubes{
        .col-service-text{
          max-width: 480px;
        }
      }

      &-space,
      &-parachute{
        @media (max-width: $mediaSmallScreen) {
          .col-service-text{
            max-width: 75%;
          }
        }
        @media (max-width: $mediaTiny) {
          .col-service-text{
            max-width: 100%;
          }
        }
      }

      &-first{
        margin-bottom: 0;
        min-height: 10px;
      }

      &-space,
      &-first{
        position: relative;
        margin-top: 0;
      }
      &-hulk{
        @media (min-width: $mediaSmallScreen) {
          padding-left: 300px;
        }

        @media (min-width: $mediaMini) {
          padding-left: 20vw;
        }
        .app-low &{
          padding-left: 15px;
        }

        @media (max-width: $mediaMob) {
          padding-left: 15px;
        }
        /*.app-high & p{
          max-width: 100%;
        }*/
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Service.vue